// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file accounts/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.RevenueItem
 */
export class RevenueItem extends Message<RevenueItem> {
  /**
   * Date of the revenue item
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * Total revenue for the item
   *
   * @generated from field: float total_revenue = 2;
   */
  totalRevenue = 0;

  /**
   * Moving average of the revenue
   *
   * @generated from field: float moving_average = 3;
   */
  movingAverage = 0;

  constructor(data?: PartialMessage<RevenueItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.RevenueItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "total_revenue", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "moving_average", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RevenueItem {
    return new RevenueItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RevenueItem {
    return new RevenueItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RevenueItem {
    return new RevenueItem().fromJsonString(jsonString, options);
  }

  static equals(a: RevenueItem | PlainMessage<RevenueItem> | undefined, b: RevenueItem | PlainMessage<RevenueItem> | undefined): boolean {
    return proto3.util.equals(RevenueItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CogsItem
 */
export class CogsItem extends Message<CogsItem> {
  /**
   * Date of the COGS item
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * Total cost of goods sold for the item
   *
   * @generated from field: float total_cogs = 2;
   */
  totalCogs = 0;

  /**
   * Moving average of the COGS
   *
   * @generated from field: float moving_average = 3;
   */
  movingAverage = 0;

  constructor(data?: PartialMessage<CogsItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CogsItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "total_cogs", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "moving_average", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CogsItem {
    return new CogsItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CogsItem {
    return new CogsItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CogsItem {
    return new CogsItem().fromJsonString(jsonString, options);
  }

  static equals(a: CogsItem | PlainMessage<CogsItem> | undefined, b: CogsItem | PlainMessage<CogsItem> | undefined): boolean {
    return proto3.util.equals(CogsItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PLItem
 */
export class PLItem extends Message<PLItem> {
  /**
   * Date of the profit and loss item
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * Total profit or loss for the item
   *
   * @generated from field: float total_profit_loss = 2;
   */
  totalProfitLoss = 0;

  /**
   * Moving average of the profit or loss
   *
   * @generated from field: float moving_average_profit_loss = 3;
   */
  movingAverageProfitLoss = 0;

  /**
   * Total revenue for the item
   *
   * @generated from field: float total_revenue = 4;
   */
  totalRevenue = 0;

  /**
   * Total cost of goods sold for the item
   *
   * @generated from field: float total_cogs = 5;
   */
  totalCogs = 0;

  constructor(data?: PartialMessage<PLItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PLItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "message", T: Timestamp },
    { no: 2, name: "total_profit_loss", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "moving_average_profit_loss", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_revenue", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "total_cogs", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PLItem {
    return new PLItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PLItem {
    return new PLItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PLItem {
    return new PLItem().fromJsonString(jsonString, options);
  }

  static equals(a: PLItem | PlainMessage<PLItem> | undefined, b: PLItem | PlainMessage<PLItem> | undefined): boolean {
    return proto3.util.equals(PLItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PaymentMethodBreakdownItem
 */
export class PaymentMethodBreakdownItem extends Message<PaymentMethodBreakdownItem> {
  /**
   * Payment method type (e.g., Cash, Card)
   *
   * @generated from field: string payment_method = 1;
   */
  paymentMethod = "";

  /**
   * Total amount for the payment method
   *
   * @generated from field: float total_amount = 2;
   */
  totalAmount = 0;

  constructor(data?: PartialMessage<PaymentMethodBreakdownItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PaymentMethodBreakdownItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PaymentMethodBreakdownItem {
    return new PaymentMethodBreakdownItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PaymentMethodBreakdownItem {
    return new PaymentMethodBreakdownItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PaymentMethodBreakdownItem {
    return new PaymentMethodBreakdownItem().fromJsonString(jsonString, options);
  }

  static equals(a: PaymentMethodBreakdownItem | PlainMessage<PaymentMethodBreakdownItem> | undefined, b: PaymentMethodBreakdownItem | PlainMessage<PaymentMethodBreakdownItem> | undefined): boolean {
    return proto3.util.equals(PaymentMethodBreakdownItem, a, b);
  }
}

